import React, { useContext } from "react";
import queryString from "query-string";
import {
  Accordion,
  AccordionContext,
  Card,
  useAccordionButton,
} from "react-bootstrap";
import {
  AiOutlineArrowLeft,
  AiOutlineMinus,
  AiOutlinePlus,
} from "react-icons/ai";
import { Link, useLocation } from "react-router-dom";

import {
  AccordionContainer,
  BackButton,
  Container,
  HeaderContainer,
} from "./styles";

const ContextAwareToggle = ({
  children,
  eventKey,
  callback = null,
}: any): JSX.Element => {
  const currentEventKey = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey)
  );

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <Card.Header onClick={() => decoratedOnClick(eventKey)}>
      {children}
      {isCurrentEventKey ? (
        <AiOutlineMinus size={14} />
      ) : (
        <AiOutlinePlus size={14} />
      )}
    </Card.Header>
  );
};

const AccordionItens = ({ step }: any): JSX.Element => {
  const location = useLocation();
  const { tab } = queryString.parse(location?.search);

  return (
    <Container>
      <BackButton
        to={{
          pathname: "/",
        }}
      >
        <AiOutlineArrowLeft /> Voltar
      </BackButton>

      <HeaderContainer>
        <h1>{step.h1}</h1>
        <h2 dangerouslySetInnerHTML={{ __html: step.h2 }} />
      </HeaderContainer>
      <AccordionContainer>
        <Accordion defaultActiveKey={`${tab}` || "1"}>
          <Card>
            <ContextAwareToggle eventKey="1" callback={() => null}>
              <span>Estou saindo do imóvel</span>
            </ContextAwareToggle>
            <Accordion.Collapse eventKey="1">
              <Card.Body>
                <p>
                  Ao sair do imóvel é preciso que solicite o{" "}
                  <b>desligamento do gás</b> ou que o novo morador da unidade
                  faça o <b>primeiro acesso</b> ao Portal Minha Ultragaz.
                </p>
                <p>
                  Para solicitar o desligamento do seu gás{" "}
                  <Link to="/">acesse o Portal Minha Ultragaz</Link> e clique em
                  &quot;desligar gás&quot;.
                </p>
                <p>
                  Para realizar o primeiro acesso no Portal Minha Ultragaz{" "}
                  <Link to="/primeiro-acesso-mi">clique aqui</Link>.
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <ContextAwareToggle eventKey="2" callback={() => null}>
              <span>Estou chegando no imóvel</span>
            </ContextAwareToggle>
            <Accordion.Collapse eventKey="2">
              <Card.Body>
                <p>
                  Para colocar a fatura do seu imóvel em seu nome é preciso
                  realizar o{" "}
                  <Link to="/primeiro-acesso-mi">primeiro acesso</Link> ao
                  Portal Minha Ultragaz.
                </p>
                <p>
                  Se você possui cadastro em nosso portal,{" "}
                  <Link to="/">faça o login</Link> e acesse &quot;adicionar nova
                  unidade&quot; no menu lateral esquerdo, siga os passos e
                  pronto!
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <ContextAwareToggle eventKey="3" callback={() => null}>
              <span>Quero solicitar Ligue ou Religue do meu gás</span>
            </ContextAwareToggle>
            <Accordion.Collapse eventKey="3">
              <Card.Body>
                <span>
                  <b>Ligue de fornecimento:</b>
                </span>
                <p>
                  Se você é o <b>novo morador do apartamento ou loja</b> o{" "}
                  <b>ligue</b> ocorre logo após realizar o{" "}
                  <Link to="/primeiro-acesso-mi">primeiro acesso</Link> ao
                  portal. A ligação de fornecimento da unidade será solicitado
                  automaticamente e ocorrerá em até 3 dias úteis.
                </p>
                <p>
                  Se você <b>já possui acesso ao Portal Minha Ultragaz</b> para
                  realizar o ligue de uma nova unidade que ainda não está em seu
                  nome{" "}
                  <Link to="/adicionar-unidade">Adicione nova unidade</Link> e o{" "}
                  <b>ligue</b> será solicitado automaticamente.
                </p>
                <p>
                  Para retomar uma unidade que já esteve em seu nome por favor,
                  entre em contato com o atendimento:
                </p>
                <p>
                  Regiões Metropolitanas: 4003-1616 Demais regiões:
                  0800-886-1616
                </p>
                <span>
                  <b>Religue de fornecimento:</b>
                </span>
                <p>
                  Quando deseja ligar a unidade que teve &quot;Bloqueio de
                  fornecimento por inadimplência&quot; ou solicitado o
                  &quot;Bloqueio de fornecimento temporário&quot;. Faça seu
                  acesso ao Portal Minha Ultragaz, clique em &quot;Ligar e
                  desligar gás&quot; e em &quot;Solicitar religue de
                  fornecimento&quot; leia as instruções e solicite seu religue.
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </AccordionContainer>
    </Container>
  );
};

export default AccordionItens;
